// First of the app's modules, before the router, Sentry or a login redirect reads the URL: takes keyvue-app's
// refresh token out of the address bar
import '@/utils/handover-token';
import { createApp } from 'vue';
import type { Plugin } from 'vue';
import { RouterLink } from 'vue-router';
import { ConfigurationPlugin, MainPlugin } from '@keyvue/one-ui';
import { configureAPIs as configureLegacyAPIs } from '@keyvue/one-api-client-legacy';
import loadSentry from '@plugins/sentry';
import EventBus from '@plugins/eventbus';
import ApiClient from '@plugins/api-client';
import App from '@/App.vue';
import router from './router';
import '@keyvue/one-ui/dist/style.css';
import 'v-calendar/style.css';
import 'quill/dist/quill.snow.css';

configureLegacyAPIs({
    baseURL: import.meta.env.VITE_LEGACY_HOST,
    basePath: import.meta.env.VITE_LEGACY_BASEPATH,
});

const app = createApp(App);
app.use(MainPlugin as unknown as Plugin);
app.use(ConfigurationPlugin as unknown as Plugin);

// Event bus as soon as possible, so we can hook into it in all parts of the application
app.use(EventBus);

// Api client before router so we can call the client from global navigation guards
app.use(ApiClient);

// Router with provided router link for use in ui package
app.use(router);
app.provide('router-link', RouterLink);

// mount
app.mount('#app');

loadSentry(app, router);
